import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SalesRoutingModule } from './sales-routing.module';
import { CustomersComponent } from './customers/customers.component';
import { SalespersonsComponent } from './salespersons/salespersons.component';
import { AppSharedModule } from '@app/shared/app-shared.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { SubheaderModule } from '@app/shared/common/sub-header/subheader.module';
import { FormsModule } from '@angular/forms';
import { Angular2CountoModule } from '@awaismirza/angular2-counto';
import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { CreateOrEditCustomerComponent } from './customers/create-or-edit-customer.component';
import { CreateOrEditSalespersonModalComponent } from './salespersons/create-or-edit-salesperson-modal.component';

import { FileUploadModule } from 'primeng/fileupload';

import { CreateOrEditSalesOrderComponent } from './salesOrders/create-or-edit-salesOrder.component';
import { SalesOrdersComponent } from './salesOrders/salesOrders.component';
import { CreateOrEditSalesInvoiceComponent } from './salesInvoices/create-or-edit-salesInvoice.component';
import { SalesInvoicesComponent } from './salesInvoices/salesInvoices.component';
import { CreateOrEditSalesReturnComponent } from './salesReturns/create-or-edit-salesReturn.component';
import { SalesReturnsComponent } from './salesReturns/salesReturn.component';
import { CreateOrEditCustomerPaymentComponent } from './customerPayments/create-or-edit-customerPayment.component';
import { CustomerPaymentsComponent } from './customerPayments/customerPayments.component';
import { PaymentDetailComponent } from './reports/payment-detail/payment-detail.component';
import { PaymentSummaryComponent } from './reports/payment-summary/payment-summary.component';
import { SalesProductAnalysisComponent } from './reports/sales-product-analysis/sales-product-analysis.component';
import { SalesAccountActivityComponent } from './reports/sales-account-activity/sales-account-activity.component';
import { SalesAgedReceivablesDetailsComponent } from './reports/sales-aged-receivables-details/sales-aged-receivables-details.component';
import { SalesAgedReceivablesComponent } from './reports/sales-aged-receivables/sales-aged-receivables.component';
import { CustomerSalesAnalysisByLocationComponent } from './reports/customer-sales-analysis-by-location/customer-sales-analysis-by-location.component';
import { CustomerSalesAnalysisComponent } from './reports/customer-sales-analysis/customer-sales-analysis.component';
import { CustomerSalesSummaryComponent } from './reports/customer-sales-summary/customer-sales-summary.component';
import { DailySalesDetailComponent } from './reports/daily-sales-detail/daily-sales-detail.component';
import { DailySalesRetunrDetailComponent } from './reports/daily-sales-retunr-detail/daily-sales-retunr-detail.component';
import { DepartmentSalesSummaryComponent } from './reports/department-sales-summary/department-sales-summary.component';
import { ItemSalesSummaryComponent } from './reports/item-sales-summary/item-sales-summary.component';
import { ItemSalesSummaryByCustomerComponent } from './reports/item-sales-summary-by-customer/item-sales-summary-by-customer.component';
import { SalesOutstandingInvoicesComponent } from './reports/sales-outstanding-invoices/sales-outstanding-invoices.component';
import { SalesDetailComponent } from './reports/sales-detail/sales-detail.component';
import { SalesRebateComponent } from './reports/sales-rebate/sales-rebate.component';
import { SalesmanSalesSummaryComponent } from './reports/salesman-sales-summary/salesman-sales-summary.component';
import { SalesmanAnalysisComponent } from './reports/salesman-analysis/salesman-analysis.component';
import { SalesReturnDetailComponent } from './reports/sales-return-detail/sales-return-detail.component';
import { DailySalesOrderDetailComponent } from './reports/sales-order/daily-sales-order-detail/daily-sales-order-detail.component';
import { DailySalesOrderComponent } from './reports/sales-order/daily-sales-order/daily-sales-order.component';
import { SalesOrderDetailComponent } from './reports/sales-order/sales-order-detail/sales-order-detail.component';
import { DeliveryOrderDetailComponent } from './reports/delivery-order/delivery-order-detail/delivery-order-detail.component';
import { DailyDeliveryOrderComponent } from './reports/delivery-order/daily-delivery-order/daily-delivery-order.component';
import { DailyDeliveryOrderDetailComponent } from './reports/delivery-order/daily-delivery-order-detail/daily-delivery-order-detail.component';


@NgModule({
  declarations: [   
    CustomersComponent,
        CreateOrEditCustomerComponent,
        SalespersonsComponent,
        CreateOrEditSalespersonModalComponent,
        CreateOrEditSalesOrderComponent,
        SalesOrdersComponent,
        CreateOrEditSalesInvoiceComponent,
        SalesInvoicesComponent,
        CreateOrEditSalesReturnComponent,
        SalesReturnsComponent,
        CreateOrEditCustomerPaymentComponent,
        CustomerPaymentsComponent,
        PaymentDetailComponent,
        PaymentSummaryComponent,
        SalesProductAnalysisComponent,
        SalesAccountActivityComponent,
        SalesAgedReceivablesDetailsComponent,
        SalesAgedReceivablesComponent,
        CustomerSalesAnalysisByLocationComponent,
        CustomerSalesAnalysisComponent,
        CustomerSalesSummaryComponent,
        DailySalesDetailComponent,
        DailySalesRetunrDetailComponent,
        DepartmentSalesSummaryComponent,
        ItemSalesSummaryComponent,
        ItemSalesSummaryByCustomerComponent,
        SalesOutstandingInvoicesComponent,
        SalesDetailComponent,
        SalesRebateComponent,
        SalesmanSalesSummaryComponent,
        SalesmanAnalysisComponent,
        SalesReturnDetailComponent,
        DailySalesOrderDetailComponent,
        DailySalesOrderComponent,
        SalesOrderDetailComponent,
        DeliveryOrderDetailComponent,
        DailyDeliveryOrderComponent,
        DailyDeliveryOrderDetailComponent
],
  imports: [
        CommonModule,
        FormsModule,
        ModalModule,
        TabsModule,
        TooltipModule,
        AppCommonModule,
        UtilsModule,
        SalesRoutingModule,
        FileUploadModule,
        AppSharedModule, 
        Angular2CountoModule,
        FileUploadModule,
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        SubheaderModule,
  ],
  providers: [
          { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
          { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
          { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
      ],
})
export class SalesModule { }
